<div class="bonus-transfer-type-pop-up">
	<button
		class="close bonus-transfer-type-pop-up__close"
		type="button"
		(click)="close()"
	>
		Закрыть
	</button>

	<div class="buttons-group">
		<h4 class="buttons-group__title">Выберите способ</h4>
		<div class="buttons-group__items">
			<a
				class="button button--reverse buttons-group__button"
				[routerLink]="
					SelfTransferRouteUtils.routeWithReplenishment.createNavigationParametersForReplenishmentFrom(
						SelfTransferRouteUtils.TransferTabsForSelfTransfers.account,
						productId
					).routerLink
				"
			>
				На свой счет
			</a>

			<a
				class="button button--reverse buttons-group__button"
				[routerLink]="['/bonus/change-program', programId]"
			>
				В другую программу лояльности
			</a>
		</div>
		<button
			type="button"
			class="button button--inverted-secondary buttons-group__button-cancel"
			(click)="close()"
		>
			Отменить
		</button>
	</div>
</div>
